import React from 'react';

export default function Focus() {
  return (
    <svg className="availabilityIcon availabilityIcon-focus" fill="none" height="32" width="32">
      <circle cx="16" cy="16" fill="#fff" r="15.5" stroke="#111" />
      <path
        d="M18.073 22.154c1.766-.473 3.206-1.708 3.913-3.33.444-.968-.567-1.934-1.515-1.486a3.11 3.11 0 0 1-4.365-1.985 3.103 3.103 0 0 1 .813-3.032c.75-.735.165-2.01-.88-1.924a7.975 7.975 0 0 0-1.071.166 5.997 5.997 0 0 0-4.243 7.348 5.982 5.982 0 0 0 7.348 4.243ZM15.26 11.649c.294-.078.578-.106.884-.14a4.238 4.238 0 0 0-1.124 4.136c.685 2.558 3.562 3.874 5.941 2.702a4.84 4.84 0 0 1-3.178 2.72 4.871 4.871 0 0 1-5.97-3.447c-.692-2.58.843-5.273 3.447-5.97Z"
        fill="#242424"
      />
    </svg>
  );
}
